import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleCreditNote,
  getSaleCreditNoteById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createSaleCreditNote,
  getSaleCreditNoteDetailsById,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  saleCreditNotes: [],
  edit: false,
  saleCreditNote: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleCreditNote: false,
  loadingNext: false,
  saveAndContinue: false,
  saleCreditNoteDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      unique: uuidv4(),
      noEffectInventory: false,
    },
  ],
  showCreateModal: false,
  selectedSaleInvoice: null,
  selectedSaleInvoiceDetails: [],
};

export const saleCreditNoteSlice = createSlice({
  name: "saleCreditNote",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setSaleInvoice: (state, action) => {
      state.selectedSaleInvoice = action.payload;
    },
    setSelectedInvoiceDetails: (state, action) => {
      state.selectedSaleInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },

    setSaleCreditNote: (state, action) => {
      state.saleCreditNote = action.payload;
    },
    saleCreditNoteDetailsUpdated: (state, action) => {
      state.saleCreditNoteDetails = action.payload.map((value) => {
        return { ...value, description: value.product?.name, unique: uuidv4() };
      });
    },
    clearSelectedOrderData: (state) => {
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
    },
    clearSaleCreditNoteDetails: (state) => {
      state.saleCreditNoteDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
          noEffectInventory: false,
        },
      ];
    },
    clearAllSaleCreditNote: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleCreditNote = false;
      state.saleCreditNote = null;
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
      state.saleCreditNoteDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
          noEffectInventory: false,
        },
      ];
    },
  },
  extraReducers: (builder) => {
    // getSaleCreditNoteById
    builder.addCase(getSaleCreditNoteById.pending, (state) => {
      state.loading = true;
      state.saleCreditNote = null;
    });
    builder.addCase(getSaleCreditNoteById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.saleCreditNote = action.payload.data;
      state.saleCreditNoteDetails = action.payload.data?.drCrNotesDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getSaleCreditNoteById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleCreditNote = null;
    });

    builder.addCase(getSaleCreditNoteDetailsById.pending, (state) => {
      state.loading = true;
      state.saleCreditNote = null;
    });
    builder.addCase(getSaleCreditNoteDetailsById.fulfilled, (state, action) => {
      state.loading = false;
      state.saleCreditNote = action.payload.data;
    });
    builder.addCase(getSaleCreditNoteDetailsById.rejected, (state) => {
      state.loading = false;
      state.saleCreditNote = null;
    });

    builder.addMatcher(
      isAnyOf(
        getSaleCreditNote.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleCreditNote = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleCreditNote.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleCreditNote = false;
        state.saleCreditNotes = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleCreditNote.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleCreditNote = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setSaleInvoice,
  setSelectedInvoiceDetails,
  setSaleCreditNote,
  saleCreditNoteDetailsUpdated,
  clearSelectedOrderData,
  clearSaleCreditNoteDetails,
  clearAllSaleCreditNote,
} = saleCreditNoteSlice.actions;

export default saleCreditNoteSlice.reducer;
